/* eslint-disable indent */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import * as React from 'react';
import {
  DialogContent,
  Grid,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Button,
  DialogTitle,
  Divider,
  Tooltip,
  Badge,
  Chip,
  ListItemButton,
  Menu,
  Drawer,
  DialogActions,
} from '@mui/material';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  Add,
  Edit,
  ExpandLess,
  LocationOn,
  NotificationsActive,
  Settings,
  Today,
} from '@mui/icons-material';
import moment from 'moment';
import { blueGrey } from '@mui/material/colors';

import { useNavigate } from 'react-router-dom';
import SelectEventTemplate from './components/SelectEventTemplate';
import CalendarEventDetailSettingsPage from '../../../../../../pages/settings/CalendarEventDetailSettingsPage';
import TaskDetailSettingsPage from '../../../../../../pages/settings/TaskDetailSettingsPage';
import BarnHorsesAutocomplete from '../../../../../Autocompletes/BarnHorses';
import Horse from '../../../../../Horse';
import AddEditLocationModalComponent from '../../../../../../pages/horse/Horse/components/LocationsCard/components/AddEditModal';
import TagReminderComponent from '../../../../../../pages/settings/TaskPage/reminders/components/TagReminder';
import { setSelectedBarnHorse } from '../../../../../../redux/app/actions';
import TagList from '../../../../../TagList';

const TaskCalendarEventMenu = ({
  tagsFilter,
  open,
  includeBarnTasks,
  includeHorseTasks,
  includeCalendarEvents,
  onClose,
  onTaskSelect,
  onCalendarEventSelect,
  selectedSlot,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openAddTaskModal, setOpenAddTaskModal] = React.useState(false);
  const [openAddCalendarEventModal, setOpenAddCalendarEventModal] = React.useState(false);

  const [selectedTaskType, setSelectedTaskType] = React.useState(null)
  const [barnHorses, setBarnHorses] = React.useState([]);
  const [expanded, setExpanded] = React.useState(false);
  const [numHorseLocationsOutsideCurrentLocation, setNumHorseLocationsOutsideCurrentLocation] = React.useState(0);
  const [numHorsesWithReminders, setNumHorsesWithReminders] = React.useState(false);
  const [openAddEditHorseLocationModal, setOpenAddEditHorseLocationModal] = React.useState(null);
  const [selectedHorseLocation, setSelectedHorseLocation] = React.useState(null);
  const [menuEl, setMenuEl] = React.useState(null)
  const [openEventTemplateMenu, setOpenEventTemplateMenu] = React.useState(false)
  const [tab, setTab] = React.useState(0);

  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const boardBarnHorses = useSelector((state) => state.board.barnHorses);
  const horseLocationsByHorse = useSelector((state) => state.location.horseLocationsByHorse)
  const selectedLocation = useSelector((state) => state.location.selectedLocation);
  const upcomingDueDates = useSelector((state) => state.board.upcomingDueDates);
  const permissions = useSelector((state) => state.user.permissions);

  React.useEffect(() => {
    if (open) {
      setOpenAddEditHorseLocationModal(false);
      setSelectedHorseLocation(null)
      setMenuEl(null);
      setOpenEventTemplateMenu(false)
      setExpanded(false);
    }
    setSelectedTaskType(null)
  }, [open])

  React.useEffect(() => {
    setNumHorseLocationsOutsideCurrentLocation(barnHorses
      .filter((bh) => horseLocationsByHorse[bh.horse.id]
        && horseLocationsByHorse[bh.horse.id].find((hl) => hl.location.id !== selectedLocation.id)).length)
    setNumHorsesWithReminders(barnHorses
      .filter((bh) => upcomingDueDates.find((tagReminder) => tagReminder.tag.id === parseInt(bh.pingumTagId, 10) && (tagReminder.status === 'Unscheduled' || tagReminder.status === 'PastDue'))).length)
  }, [barnHorses])

  React.useEffect(() => {
    if (selectedSlot) {
      setBarnHorses((selectedSlot.barnHorses && selectedSlot.barnHorses
        .filter((id) => !!barnHorsesMap[parseInt(id, 10)]).map((id) => barnHorsesMap[parseInt(id, 10)][0])) || []);
      if (selectedSlot.taskType) {
        setSelectedTaskType(selectedSlot.taskType);
      }
    }
  }, [selectedSlot]);
  return (
    <Drawer
      // variant="persistent"
      anchor="right"
      // hideBackdrop
      id="quick-select-task-calendar-event-type-menu"
      PaperProps={{
        sx: {
          m: 0,
          maxWidth: 450,
          width: 450,
        },
      }}
      open={!!open}
      onClose={() => onClose(false)}
    >
      <Box
        sx={{ mt: '4rem' }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            py: 0,
            px: 2,
          }}
        >
          <Box>
            {/* {
              activeStep === 1 && selectedTaskType
                ? (

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                      }}
                    >
                      <Avatar
                        sx={{
                          backgroundColor: (selectedTaskType.eventDataDefaultValues
                            && selectedTaskType.eventDataDefaultValues.calendarDisplayColor)
                            || primary.main,
                          height: 50,
                          width: 50,
                        }}
                      ><Task sx={{ fontSize: '2rem' }} />
                      </Avatar>
                      <Box
                        sx={{
                          fontWeight: 600,
                          fontSize: 32,
                        }}
                      >Review {selectedTaskType.name}
                      </Box>
                    </Box>

                    <IconButton
                      onClick={(e) => {
                        setMenuEl(e.currentTarget);
                        setOpenEventTemplateMenu(true)
                      }}
                    >
                      <MoreVert />
                    </IconButton>
                  </Box>
                )
                : (
                  <Box sx={{ fontWeight: 600 }}>Create Task or Event</Box>
                )
            } */}
            {
              selectedSlot && selectedSlot.start && !selectedTaskType && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                  }}
                >
                  <Today color="secondary" fontSize="small" /><Typography fontSize={12}>{moment(selectedSlot.start).format('dddd MMMM Do')}</Typography>
                </Box>
              )
            }
            {
              selectedTaskType && (
                <Box>
                  <TagList tags={selectedTaskType.tags} disableGutters />
                </Box>
              )
            }

            {/* {
              activeStep === 1 && selectedTaskType && selectedTaskType.description && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    mt: 0.5,
                  }}
                >
                  <Info color="secondary" />
                  <Box sx={{ fontSize: '0.9rem' }}>{selectedTaskType.description}</Box>
                </Box>
              )
            } */}

          </Box>

          <Box
            sx={{
              mt: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <BarnHorsesAutocomplete
              multiple
              label="Horse(s)"
              pickerTitle="Select Horse(s) for Task"
              value={barnHorses}
              onSelectedBarnHorseChange={(newHorses) => {
                setBarnHorses(newHorses);
              }}
              onSelect={(e, newHorses) => {
                setBarnHorses(newHorses)
              }}
              limitTags={5}
              barnHorses={boardBarnHorses}
            />
            {
              includeHorseTasks && barnHorses.length > 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    ml: 1,
                    alignItems: 'center',
                  }}
                >
                  <Tooltip title="View Locations of Selected Horses">
                    <IconButton aria-label="Horse Locations" onClick={() => setExpanded(!expanded)}>
                      <Badge badgeContent={numHorseLocationsOutsideCurrentLocation} color="primary" invisible={numHorseLocationsOutsideCurrentLocation <= 0}>
                        <LocationOn color="secondary" />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="View Reminders of Selected Horses">
                    <IconButton aria-label="Horse Reminders" onClick={() => setExpanded(!expanded)}>
                      <Badge badgeContent={numHorsesWithReminders} color="primary" invisible={numHorsesWithReminders <= 0}>
                        <NotificationsActive color="error" />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                </Box>
              )
            }
          </Box>
        </DialogTitle>
        <Divider sx={{ my: 1 }} />
      </Box>
      <DialogContent sx={{ p: 0 }}>
        <Grid container spacing={1}>
          {
            !expanded && (
              <Grid item sx={{ flex: 1 }}>
                <SelectEventTemplate
                  tagsFilter={tagsFilter}
                  open={open}
                  includeBarnTasks={includeBarnTasks}
                  includeHorseTasks={includeHorseTasks}
                  includeCalendarEvents={includeCalendarEvents}
                  onTaskSelect={(et) => {
                    // setSelectedTaskType(et);
                    // setActiveStep(1)
                    if (et) {
                      onTaskSelect(et, {
                        ...selectedSlot,
                        barnHorses: barnHorses.map((bh) => bh.pingumTagId),
                      });
                    }
                  }}
                  onCalendarEventSelect={(et) => {
                    onCalendarEventSelect(et);
                  }}
                  selectedSlot={selectedSlot}
                  setOpenAddCalendarEventModal={setOpenAddCalendarEventModal}
                  setOpenAddTaskModal={setOpenAddTaskModal}
                  tab={tab}
                  setTab={setTab}
                />
                {/* {
                  activeStep === 1 && (
                    <Collapse in={activeStep === 1} orientation="horizontal" sx={{ height: '100%' }}>
                      <SelectWorkflows
                        selectedSlot={{
                          ...selectedSlot,
                          barnHorses: barnHorses.map((bh) => bh.pingumTagId),
                        }}
                        selectedEventTemplate={selectedTaskType}
                        onConfirm={(replacementSlot) => {
                          if (selectedTaskType) { onTaskSelect(selectedTaskType, replacementSlot); }
                        }}
                        onBack={() => { setSelectedTaskType(null); setActiveStep(0); }}
                        onClose={onClose}
                        onEditEventTemplate={() => { }}
                        barnHorses={barnHorses}
                        setBarnHorses={setBarnHorses}
                      />
                    </Collapse>
                  )
                } */}
              </Grid>
            )
          }
          {expanded && (
            <Grid item xs={12} justifyContent="center" alignContent="center" sx={{ textAlign: 'center' }}>
              <Button variant="outlined" onClick={() => setExpanded(!expanded)} endIcon={<ExpandLess />}>Hide Locations & Reminders</Button>
            </Grid>
          )}
          {expanded && (
            <Grid
              item
              xs={12}
            >
              <Box
                sx={{
                  backgroundColor: blueGrey[50],
                  borderRadius: 4,
                  p: 2,
                  mx: 2,
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 1,
                        alignItems: 'center',
                      }}
                    >
                      <LocationOn color="secondary" />
                      <Typography
                        variant="h6"
                        component="h3"
                        fontWeight={500}
                        sx={{ fontSize: '1.2rem' }}
                      >
                        Current Location(s) of Horses
                      </Typography>
                    </Box>
                    <Tooltip title="Add Horses to Location">
                      <IconButton
                        sx={{ padding: 0 }}
                        onClick={() => {
                          setSelectedHorseLocation(null); setOpenAddEditHorseLocationModal(true);
                        }}
                      >
                        <Add />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <List
                    sx={{
                      width: '100%',
                      maxHeight: 400,
                      height: 400,
                      overflow: 'auto',
                    }}
                    dense
                  >
                    {barnHorses.filter((bh) => horseLocationsByHorse[bh.horse.id]).map((bh) => (
                      <ListItem
                        divider
                        key={bh.id}
                        disablePadding
                      >
                        <Box
                          sx={{
                            flex: 1,
                            mt: 1,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <Horse horse={bh.horse} size={32} textWidth={90} clickable onClick={() => { dispatch(setSelectedBarnHorse(bh)); }} />
                            {
                              horseLocationsByHorse[bh.horse.id].filter((hl) => hl.location.id !== selectedLocation.id).length > 0 && (
                                <Chip size="small" variant="outlined" color="warning" label="Multiple Locations Found" />
                              )
                            }
                          </Box>
                          <List
                            dense
                            sx={{
                              width: '100%',
                              py: 0,
                            }}
                          >
                            {
                              horseLocationsByHorse[bh.horse.id].map((hl) => (
                                <ListItem
                                  key={hl.id}
                                  disablePadding
                                  secondaryAction={(
                                    <IconButton
                                      onClick={() => { setSelectedHorseLocation(hl); setOpenAddEditHorseLocationModal(true); }}
                                    ><Edit />
                                    </IconButton>
                                  )}
                                >
                                  <Box sx={{ flex: 1 }}>

                                    <ListItemText
                                      primary={hl.location.name}
                                      secondaryTypographyProps={{ component: 'div' }}
                                      secondary={(
                                        <Box>
                                          <div>{`${moment(hl.startDate).format('ll')} - ${!hl.endDate
                                            ? 'No End Date'
                                            : moment(hl.endDate).format('ll')}`}
                                          </div>
                                          {
                                            hl.location.id === selectedLocation.id && <Chip size="small" label="Current Planning Location" />
                                          }
                                        </Box>
                                      )}
                                    />
                                  </Box>
                                </ListItem>
                              ))
                            }
                          </List>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Box>
            </Grid>
          )}
          {expanded && (
            <Grid
              item
              xs={12}
            >
              <Box
                sx={{
                  backgroundColor: blueGrey[50],
                  borderRadius: 4,
                  p: 2,
                  mx: 2,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                  }}
                >
                  <NotificationsActive color="error" />
                  <Typography
                    variant="h6"
                    component="h3"
                    fontWeight={500}
                    sx={{ fontSize: '1.2rem' }}
                  >
                    Reminders
                  </Typography>
                </Box>
                <Box>
                  <List
                    sx={{
                      width: '100%',
                      maxHeight: 400,
                      height: 400,
                      overflow: 'auto',
                    }}
                    dense
                  >
                    {barnHorses.map((bh) => {
                      const horseReminders = upcomingDueDates.filter((tagReminder) => tagReminder.tag.id === parseInt(bh.pingumTagId, 10) && (tagReminder.status === 'Unscheduled' || tagReminder.status === 'PastDue'));

                      return (
                        <ListItem
                          divider
                          key={bh.id}
                          disablePadding
                        >
                          <Box
                            sx={{
                              flex: 1,
                              mt: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <Horse horse={bh.horse} size={32} textWidth={90} clickable onClick={() => { dispatch(setSelectedBarnHorse(bh)); }} />
                              {
                                horseReminders.length > 0 && (
                                  <Chip size="small" variant="outlined" color="warning" label="Reminders Found" />
                                )
                              }
                            </Box>
                            {
                              horseReminders.length > 0
                                ? (
                                  <List
                                    dense
                                    sx={{
                                      width: '100%',
                                      py: 0,
                                    }}
                                  >
                                    {
                                      horseReminders.map((tr) => (
                                        <ListItem
                                          key={tr.id}
                                          disablePadding
                                        // secondaryAction={(
                                        //   <IconButton
                                        //     onClick={() => { setSelectedHorseLocation(hl); setOpenAddEditHorseLocationModal(true); }}
                                        //   ><Edit />
                                        //   </IconButton>
                                        // )}
                                        >
                                          {/* <ListItemIcon>
                                            <LocationOn />
                                          </ListItemIcon> */}
                                          <Box sx={{ flex: 1 }}>
                                            <TagReminderComponent
                                              key={`task-item-${tr.id}`}
                                              tagReminder={tr}
                                              fullScreen={false}
                                              includeHorse={false}
                                              includeTask
                                              condensed
                                            />
                                          </Box>
                                        </ListItem>
                                      ))
                                    }
                                  </List>
                                )
                                : (
                                  <Typography color="secondary" gutterBottom>No upcoming reminders</Typography>
                                )
                            }
                          </Box>
                        </ListItem>
                      )
                    })}
                  </List>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>

        <Menu
          id="menu-appbar"
          anchorEl={menuEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorPosition={{
            top: 0,
            left: 0,
          }}
          open={openEventTemplateMenu}
          onClose={() => {
            setMenuEl(null);
            setOpenEventTemplateMenu(false)
          }}
        >
          <ListItemButton
            onClick={() => {
              setOpenAddTaskModal(true)
              setMenuEl(null);
              setOpenEventTemplateMenu(false)
            }}
          >
            <ListItemIcon>
              <Settings color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Edit Task Type" secondary="Manage default settings for all occurrences of this task type" />
          </ListItemButton>
        </Menu>

        <CalendarEventDetailSettingsPage
          modal
          navigate={() => { }}
          openModal={openAddCalendarEventModal}
          passedInModalId="new"
          onCloseModal={(newCalendarEvent) => {
            setOpenAddCalendarEventModal(false);
            if (newCalendarEvent && newCalendarEvent.id) {
              onCalendarEventSelect(newCalendarEvent);
            }
          }}
        />

        <TaskDetailSettingsPage
          modal
          navigate={() => { }}
          openModal={openAddTaskModal}
          passedInModalId={selectedTaskType
            ? `${selectedTaskType.id}`
            : 'new'}
          onCloseModal={(newTaskType) => {
            setOpenAddTaskModal(false);
            if (newTaskType && newTaskType.id) {
              setSelectedTaskType(newTaskType);
              onTaskSelect(newTaskType, {
                ...selectedSlot,
                barnHorses: barnHorses.map((bh) => bh.pingumTagId),
              });
            }
          }}
        />
        <AddEditLocationModalComponent
          open={!!openAddEditHorseLocationModal}
          horseIds={barnHorses.map((bh) => bh.id)}
          onClose={() => { setOpenAddEditHorseLocationModal(false); setSelectedHorseLocation(null) }}
          startDate={new Date()}
          endDate={null}
          location={selectedLocation}
          horseId={selectedHorseLocation && selectedHorseLocation.horse.id}
          horseLocation={selectedHorseLocation}
        />
      </DialogContent>

      <Divider />
      <DialogActions
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        {(permissions.admin || permissions.owner)
          ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 1,
                width: '100%',
              }}
            >
              <Typography
                component="span"
                sx={{ fontWeight: 300 }}
              >Don&#39;t see the right option?
              </Typography>
              {
                tab === 0
                  ? (
                    <Box><Button size="small" color="secondary" onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate('/settings/tasks') }} endIcon={<Settings />}>Manage Tasks</Button></Box>
                  )
                  : (

                    <Box><Button size="small" color="secondary" onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate('/settings/calendar') }} endIcon={<Settings />}>Manage Calendars</Button></Box>
                  )
              }
            </Box>

          )
          : <Box />}
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
            alignItems: 'center',
            width: '100%',
          }}
        >
          {(permissions.admin || permissions.owner)
            ? (
              tab === 0
                ? (
                  <Box><Button variant="outlined" size="small" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectedTaskType(null); setOpenAddTaskModal(true) }} endIcon={<Add />}>New Task</Button></Box>
                )
                : (
                  <Box><Button variant="outlined" size="small" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpenAddCalendarEventModal(true) }} endIcon={<Add />}>New Calendar</Button></Box>
                )
            )
            : <Box />}
          <Button onClick={onClose} variant="contained" sx={{ flex: 1 }}>Cancel</Button>
        </Box>
      </DialogActions>
    </Drawer>
  )
}

TaskCalendarEventMenu.propTypes = {
  tagsFilter: PropTypes.array,
  open: PropTypes.bool,
  includeBarnTasks: PropTypes.bool,
  includeHorseTasks: PropTypes.bool,
  includeCalendarEvents: PropTypes.bool,
  onClose: PropTypes.func,
  onTaskSelect: PropTypes.func,
  onCalendarEventSelect: PropTypes.func,
  selectedSlot: PropTypes.object,
};

TaskCalendarEventMenu.defaultProps = {
  tagsFilter: [],
  open: false,
  includeBarnTasks: true,
  includeHorseTasks: false,
  includeCalendarEvents: true,
  onClose: () => { },
  onTaskSelect: () => { },
  onCalendarEventSelect: () => { },
  selectedSlot: null,
};

export default TaskCalendarEventMenu;
